import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const MovementYearOnYearPage = lazy(() => import('./MovementYearOnYearPage'));
const path = 'reports/movement-yoy';
const MovementYearOnYearRoute: FuseRouteItemType = {
	path: path,
	element: <MovementYearOnYearPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Year on Year Movement',
					helpName: 'Movement Year on Year',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default MovementYearOnYearRoute;
